import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Nav from "./components/Navbar";
import Home from "./components/Home.js";
import Menus from "./components/Menus/";
import Footer from "./components/Footer";
import { GlobalStyles } from "./GlobalStyles";

const App = () => {
	return (
		<Router>
			<Nav></Nav>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/kokamenu" element={<Menus />} />
			</Routes>
			<Footer />
			<GlobalStyles />
		</Router>
	);
};

export default App;
